module.exports = __webpack_public_path__ + "static/media/8.66dd8a03.jpg";